import {PaymentMethod, PaymentMethodAdditional} from 'Common/constants/PaymentMethod';

export interface IFormValues {
  paymentMethod: PaymentMethod | PaymentMethodAdditional;
}

export const initialValues: IFormValues = {
  paymentMethod: PaymentMethod.Stripe,
};
